module.exports = __webpack_public_path__ + "img/raw_material_processing_1200x800.68cf9d79.svg";